// @owners { team: patient-health }
import { openModal } from '~shared/actions/modal';
import { updateCashPay } from '~shared/actions/users';
import { getCurrentUserID } from '~shared/features/users/selectors/getUsers';
import { connect } from '~shared/store';
import { type ReduxStateShared } from '~shared/types';
import NeedsInsurance from './NeedsInsurance';

const mapStateToProps = (state: ReduxStateShared) => {
  const userID = getCurrentUserID(state);
  return {
    userID,
  };
};

const mapDispatchToProps = {
  updateCashPay,
  openModal,
};

// @ts-expect-error TS(7006): Parameter 'stateProps' implicitly has an 'any' type.
const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const { userID, ...newStateProps } = stateProps;
  const { updateCashPay: updateUserCashPay, ...newDispatchProps } = dispatchProps;

  return {
    ...newStateProps,
    ...ownProps,
    ...newDispatchProps,
    updateCashPay: () => {
      updateUserCashPay(userID, true);
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(NeedsInsurance);
